import { Container, Grid, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import UserRole from '../../../shared/AuthRoles';
import AdminCentreList from './AdminCentreList';

const AdminCentrePage = () => {
    const isMobile = useMediaQuery('(max-width: 770px)');
    const isIpad = useMediaQuery('(max-width: 1200px)');
    const loggedInUser = UserRole();
    const navigate = useNavigate();

    useEffect(() => {
        if (
            loggedInUser.role === 'owner_user' ||
            loggedInUser.role === 'guest_user'
        ) {
            navigate(`/permissionDenied`, {
                state: {
                    name: 'adminCentrePage',
                },
            });
        }
    }, [loggedInUser.role]);

    return (
        <Grid
            sx={{
                width: '100%',
                minHeight: 'calc(100vh - var(--app-prompt-banner-height, 0px))',
                overflowY: 'auto',
                justifyContent: 'left',
                alignItems: 'center',
                pb: '30px',
            }}
        >
            <Grid
                sx={{
                    width: '100%',
                    height: isMobile || isIpad ? '2%' : '5%',
                    justifyContent: 'left',
                    display: 'flex',
                }}
            >
                <Typography
                    variant='h1'
                    sx={{
                        textAlign: 'left',
                        textTransform: 'uppercase',
                    }}
                >
                    Admin Centre
                </Typography>
            </Grid>
            <AdminCentreList />
        </Grid>
    );
};

export default AdminCentrePage;
